var _ContentHistoryServiceInit_histories;
import { __classPrivateFieldGet } from "tslib";
import { writable } from "svelte/store";
const MAX_RECENT_COUNT = 10;
class ContentHistoryServiceInit {
    constructor() {
        _ContentHistoryServiceInit_histories.set(this, writable([]));
    }
    get histories() {
        return __classPrivateFieldGet(this, _ContentHistoryServiceInit_histories, "f");
    }
    addHistory(history) {
        __classPrivateFieldGet(this, _ContentHistoryServiceInit_histories, "f").update(it => {
            if (it.every(h => !this.checkEqual(h, history))) {
                const next = [history, ...it].filter((_, i) => i < MAX_RECENT_COUNT);
                return next;
            }
            else {
                return it;
            }
        });
    }
    removeHistory(history) {
        __classPrivateFieldGet(this, _ContentHistoryServiceInit_histories, "f").update(it => {
            return it.filter(h => !this.checkEqual(h, history));
        });
    }
    checkEqual(h1, h2) {
        return h1.description === h2.description &&
            h1.icon === h2.icon &&
            h1.link === h2.link &&
            h1.thumbnail === h2.thumbnail &&
            h1.title === h2.title;
    }
}
_ContentHistoryServiceInit_histories = new WeakMap();
export const ContentHistoryService = new ContentHistoryServiceInit();
